import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Svg from 'atoms/Svg'
import StepButton from './StepButton'

const styles = {
  svg: {
    width: 30 * 0.65,
    height: 30 * 0.65,
    verticalAlign: 'top',
  },
  withChildren: {
    marginRight: 15 * 0.65,
  },
}

const OnboardingStepButtonIcon = ({ classes, icon, children, ...rest }) => (
  <StepButton {...rest} round>
    <Svg
      className={classNames(classes.svg, { [classes.withChildren]: !!children })}
      {...icon}
    />
    { children }
  </StepButton>
)

OnboardingStepButtonIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  children: PropTypes.any,
}

export default withStyles(styles)(OnboardingStepButtonIcon)
